"use strict";

var classApi = require("./chunks/classApi.cjs");

exports.Intl = classApi.IntlExtended, exports.Temporal = classApi.Temporal, exports.toTemporalInstant = classApi.toTemporalInstant;
